var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16873 2.77135C2.86964 4.48209 16.8468 4.36664 16.8992 2.40507M6.11216 12.0335C7.3729 12.0335 7.90529 10.7803 7.34775 9.80323L6.15408 7.69577L4.87761 9.80323C4.24671 10.9661 4.95726 12.0335 6.11216 12.0335ZM16.9998 2.64121V13.295C16.9998 15.5683 1 15.5683 1 13.295V2.64121C1.05764 0.448734 17.0564 0.45713 16.9998 2.64121Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTank);
export default __webpack_public_path__ + "static/media/water-tank.70d2a15cbdf993603d7c3bcd3e42e4fb.svg";
export { ForwardRef as ReactComponent };